import React, { useEffect, useState } from 'react';
import { readScopedToken } from '../../session/storage.js';

export function AccountAvatar({ sourceUrl, displayName, className }: {
  sourceUrl: string | null;
  displayName: string;
  className: string;
}) {
  const [imageUrl, setImageUrl] = useState<string | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setImageUrl(null);
    setFailed(false);
    if (!sourceUrl) return;

    const controller = new AbortController();
    let objectUrl: string | null = null;
    const token = readScopedToken();

    void fetch('/api/account/avatar', {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
      signal: controller.signal,
    })
      .then((response) => {
        if (!response.ok) throw new Error(`avatar_${response.status}`);
        return response.blob();
      })
      .then((blob) => {
        if (controller.signal.aborted) return;
        objectUrl = URL.createObjectURL(blob);
        setImageUrl(objectUrl);
      })
      .catch(() => {
        if (!controller.signal.aborted) setFailed(true);
      });

    return () => {
      controller.abort();
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [sourceUrl]);

  if (imageUrl && !failed) {
    return (
      <img
        className={className}
        src={imageUrl}
        alt=""
        referrerPolicy="no-referrer"
        onError={() => setFailed(true)}
      />
    );
  }

  const initials = displayName
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part.charAt(0))
    .join('')
    .toUpperCase() || '?';

  return (
    <span className={`${className} account-avatar-fallback`} aria-hidden="true">
      {initials}
    </span>
  );
}
